export const removeSubScopeById = (scopes, id) => {
	return scopes?.filter((scope) => !(scope?.gaScopeId === id && scope?.isSubScope));
};
